// extracted by mini-css-extract-plugin
module.exports = {"styles":"_1BPUtkL05ZpTRANJ7fTlFL"};